<template>
  <div>
    <v-row v-show="showList">
      <v-col cols="12">
        <RecursosPorCompetenciaFilter :getRecursosGlosa="payload => getList(payload, 1)" />
      </v-col>
    </v-row>

    <v-row wrap>
      <v-col class="col-xs-12 col-sm-12 col-md-12 py-0 px-4">
        <List
          v-show="showList"
          tipoFiltro="COMPETENCIA"
          :openModal="()=>openModal()"
          :list="filteredList"
          :filterData="filterList"
          :getList="(filterData, page) => getList(filterData, page)"
          :getPagamentos="(id) => getPagamentos(id)"
          :headers="headers"
          :pagination="pagination"
          :pagtoList="pagtoList"
          :selectItem="(id) => goTodetails(id)"
          :statusList="statusList"
          :uploadRecurso="(pagamento) => openUploadRecurso(pagamento)"
          :totais="totaisGlosa"
        />
      </v-col>
    </v-row>
    <UploadRecursoDlg
      :close="
        () => {
          getList(filterList, pagination.offset);
          showUploadDlg = false;
        }
      "
      :dialog="showUploadDlg"
      :grupoEconomico="grupoEconomico"
      :dadosPagamento="selectedItem"
    />
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'

import List from '@/components/recebiveis/recursos_de_glosa/List'
import RecursosPorCompetenciaFilter from '@/components/recebiveis/recursos_de_glosa/RecursosPorCompetenciaFilter'
import UploadRecursoDlg from '@/components/recebiveis/recursos_de_glosa/UploadRecursoDlg'

export default {
  components: {
    List,
    RecursosPorCompetenciaFilter,
    UploadRecursoDlg,
  },
  data() {
    return {
      filteredList: [],
      statusList: [],
      pagtoList: [],
      filterList: {},
      headers: [
        {
          text: "Data do Pgto",
          value: "date_pag",
          align: "center",
          sortable: false,
        },
        {
          text: "Prazo do Recurso",
          value: "date_prazo",
          align: "center",
          sortable: false,
        },
        {
          text: "Operadora",
          value: "oper_nome",
          align: "left",
          sortable: false,
        },
        {
          text: "Prestador",
          value: "prest_nome",
          align: "left",
          sortable: false,
        },
        {
          text: "Vl.informado",
          value: "pagto_estimado",
          align: "right",
          sortable: false,
        },
        {
          text: "Vl.liberado",
          value: "val_liberado",
          align: "right",
          sortable: false,
        },
        {
          text: "Vl.glosado",
          value: "pagto_glossado",
          align: "right",
          sortable: false,
        },
        {
          text: "Vl.recursado",
          value: "val_glos_rec",
          align: "right",
          sortable: false,
        },
        {
          text: "Vl.acatado",
          value: "val_glos_acat",
          align: "right",
          sortable: false,
        },
        { text: "Estado", value: "status", align: "center", sortable: false },
      ],
      pagination: {
        limit: 20,
        offset: 1,
        current_page: 1,
        total_pages: 1,
      },
      paginationPagto: {
        limit: 10,
        offset: 1,
        current_page: 1,
        total_pages: 1,
      },
      showList: true,
      showPgto: false,
      showUploadDlg: false,
      selectedItem: {},
      totaisGlosa: {
        valor_informado: 0,
        valor_liberado: 0,
        valor_liberado_producao: 0,
        valor_glosado: 0,
        valor_recursado: 0,
        perc_conciliado: 0,
        valor_glosa_mantida: 0,
        valor_liberado_recurso: 0,
        valor_acatado: 0,
      }
    }
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico
    }),
  },
  methods: {
    openModal() {
      const confirmModalParams = {
          type: 'warning',
          title: `Finalizar envio de recurso`,
          message: `<b>Deseja finalizar o recurso de glosa da competência ${moment(this.filterList.data_entre).format('MMMM YYYY')}?</b><br>Confira os dados, não é possível desfazer essa ação.`,
          callback: ()=> { this.submitRecursosGlosa(this.filterList)},
          btConfirm: { name: 'Finalizar', show: true },
          btCancel: { name: 'Cancelar', show: true },
        };
      this.$store.commit('confirmMessage/showConfirmMessage', confirmModalParams);
    },
    submitRecursosGlosa(filterList){
      const obj = {
        query: [{ 
          Modulo: 'Recebiveis',
          Acao: 'finalizaenviorecursoglosa',
          Payload: {
            grupo_economico: this.grupoEconomico,
            prestador_id: filterList.prestador_id[0],
            operadora_ans_id: filterList.operadora_ans_id[0],
            data_inicio: moment(filterList.data_entre).format('YYYY-MM-DD'),
            data_fim: moment(filterList.data_ate).endOf('month').format('YYYY-MM-DD')
          }
        }],
      }
      this.$store.dispatch('request/doRequest', obj)
        .then(response => {
          if (!response || response.isAxiosError || !response.sucesso) {
            this.$store.commit('hideLoader')
            return;
          }
          const paramModal = {
            type: 'success',
            title: 'Sucesso!',
            message: response.mensagem,
            callback: null,
            btConfirm: { name: 'Ok', show: true },
            btCancel: { show: false }
          }
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
    openUploadRecurso(pagamento) {
      if (pagamento.erro_validacao) {
        let paramModal = {
          type: "warning",
          title: "Atenção!",
          message:
            "Existem arquivos com erro! <br>Exclua os arquivos com erro antes de enviar novos arquivos.",
          callback: null,
          btConfirm: { name: "Ok", show: true },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        return;
      }
      this.selectedItem = pagamento;
      this.showUploadDlg = true;
    },
    getEtapasPagamento(payload) {
      let obj = {
        query: [{ modulo: "Recebiveis", acao: "getetapaspagamento", payload }],
      };
      this.$store
        .dispatch("request/doRequest", obj, { root: true })
        .then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader");
            return;
          }
          this.statusList = response.dados;
        });
    },
    saveFilter(filter) {
      this.filterList = filter;
      this.filterList.grupo_economico = this.grupoEconomico;

      let opts = {
        filterData: {
          grupo_economico: this.grupoEconomico,
          ...filter,
        },
        filterName: "recursosGlosaFilter",
        redirect: false,
      };
      this.$store.commit("recebiveis/setFilter", opts, { root: true });
    },
    async getList(filter, page) {
      this.filteredList = [];
      this.filterList = filter ? filter : this.filterList;
      this.pagination.offset = page ? page : 1;
      let payload = Object.assign(
        this.pagination,
        { grupo_economico: this.grupoEconomico },
        this.filterList 
      );
      let obj = {
        query: [
          { modulo: "Recebiveis", acao: "getrecursosglosa", payload: payload },
        ],
      };
      this.$store
        .dispatch("request/doRequest", obj, { root: true })
        .then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader");
            return;
          }
          let {
            total_pages,
            current_page,
            dados,
            perc_conciliado,
            valor_informado,
            valor_liberado,
            valor_recursado,
            valor_acatado,
            valor_liberado_producao,
            valor_glosado,
            valor_liberado_recurso,
            valor_glosa_mantida,
          } = response;

          this.filteredList = dados;
          this.pagination.total_pages = total_pages;
          this.pagination.offset = current_page;
          this.pagination.current_page = current_page;
          this.totaisGlosa.valor_informado = valor_informado;
          this.totaisGlosa.valor_liberado = valor_liberado;
          this.totaisGlosa.valor_glosado = valor_glosado;
          this.totaisGlosa.valor_glosa_mantida = valor_glosa_mantida;
          this.totaisGlosa.valor_recursado = valor_recursado;
          this.totaisGlosa.valor_acatado = valor_acatado;
          this.totaisGlosa.valor_liberado_recurso = valor_liberado_recurso;
          this.totaisGlosa.valor_liberado_producao = valor_liberado_producao;
          this.totaisGlosa.perc_conciliado = perc_conciliado;

          this.saveFilter(filter);
        });
    },
    getPagamentos(id, page) {
      this.pagtoList = [];
      this.paginationPagto.offset = page ? page : 1;
      let payload = Object.assign(this.paginationPagto, {
        grupo_economico: this.grupoEconomico,
        id: id,
      });
      let obj = {
        query: [
          {
            modulo: "Recebiveis",
            acao: "getrecursosglosapagamentos",
            payload: payload,
          },
        ],
      };
      this.$store
        .dispatch("request/doRequest", obj, { root: true })
        .then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader");
            return;
          }
          let { total_pages, current_page, dados } = response;
          this.pagtoList = dados;
          this.paginationPagto.total_pages = total_pages;
          this.paginationPagto.offset = current_page;
          this.paginationPagto.current_page = current_page;
        });
    },
  },
  beforeMount() {
    this.getEtapasPagamento({ origem: 'recurso' })
  }
}
</script>
<style>
</style>